import SettingMer from '@/libs/settingMer';
import noticeHandle from '@/libs/noticeHandle';
import ElementUI from 'element-ui';
import { roterPre } from '@/settings';
import { messageListApi } from '@/api/public';
import store from '@/store';
import { noticeMessageReadApi } from '@/api/user';
import { EventBus } from '@/libs/bus';
var limitConnect = 40; // 断线重连次数
var timeToken = '';
var audioUrl = require('../assets/audio/tip.mp3');
var audioTip = new Audio(audioUrl);
var notifications = {};
function notice(token) {
  var ws = new WebSocket("".concat(SettingMer.wsSocketUrl, "/ws?type=ent&token=").concat(token));
  timeToken = token;
  var ping;
  function send(type, data) {
    ws.send(JSON.stringify({
      type: type,
      data: data
    }));
  }
  ws.onopen = function () {
    console.log('webSocket open');
    limitConnect = 40;
    ping = setInterval(function () {
      send('ping');
    }, 10000);
  };
  ws.onmessage = function (res) {
    var data = JSON.parse(res.data);
    if (data.type === 'notice') {
      var close = function close() {
        notifications[message.uniqid].close();
        delete notifications[message.uniqid];
        batchMessageRead(1, {
          ids: [message.id]
        });
      };
      var message = data.data;
      audioTip.play();
      var imgShow = message.image;
      var content = "\n        <a onclick=\"onNotice()\" href=\"".concat(roterPre).concat(message.url, "\">\n          <div class='el-row display-align'>\n            <div class='el-col el-col-24 left' ").concat(imgShow == '' ? 'style="display:none"' : 'style="display:block"', ">\n               <img src='").concat(imgShow, "' alt='' style=\"width:55px;height:55px\" >\n            </div>\n            <div ").concat(imgShow == '' ? 'class="el-col el-col-24 right width100"' : 'class="el-col el-col-24 right"', ">\n              <p class='title over-text'>").concat(message.title, "</p>\n              <p class='caption over-text2'>").concat(message.message, "</p>\n            </div>\n          </div>\n        </a>");
      if (message.buttons.length > 0) {
        for (var i = 0; i < message.buttons.length; i++) {
          var value = message.buttons[i];
          content += "<div class='text-right'>\n            <button type=\"button\" class=\"el-button el-button--text el-button--small\" onclick=\"onConfirm(".concat(i, ")\"><span>").concat(value.title, "</span></button>\n          </div>");
        }
      }
      var notify = ElementUI.Notification({
        title: '消息',
        dangerouslyUseHTMLString: true,
        message: content,
        duration: 10000,
        offset: 60,
        iconClass: 'iconfont iconxiaoxi',
        customClass: 'message-socket'
      });
      notifications[message.uniqid] = notify;
      getMessage();
      window.onConfirm = function (index) {
        var item = message.buttons[index];
        EventBus.$emit('messageSuccess', {
          item: item,
          detail: message
        });
        close();
      };
      window.onCancel = function () {
        noticeHandle(message, 0);
        close();
      };
      window.onNotice = function () {
        close();
      };
    }
  };
  ws.onclose = function (e) {
    EventBus.$emit('close', e);
    reconnect();
    clearInterval(ping);
  };
  ws.onerror = function (event) {
    reconnect();
  };
  return function () {
    ws.close();
  };
}

// 重连
function reconnect() {
  // lockReconnect加锁，防止onclose、onerror两次重连
  if (limitConnect > 0) {
    if (!localStorage.getItem('lockReconnect')) {
      localStorage.setItem('lockReconnect', 1);
      limitConnect--;
      console.log('第' + (40 - limitConnect + 1) + '次重连');
      // 进行重连
      setTimeout(function () {
        notice(timeToken);
        localStorage.removeItem('lockReconnect');
      }, 10000);
    }
  } else {
    console.log('webSocket连接已超时');
  }
}
// 批量标记未已读
function batchMessageRead(status, data) {
  noticeMessageReadApi(status, data).then(function (res) {
    getMessage();
  }).catch(function (error) {
    // console.log(error.message);
  });
}
// 消息数量
function getMessage() {
  messageListApi({
    page: 1,
    limit: 5
  }).then(function (res) {
    var num = res.data.messageNum ? res.data.messageNum : 0;
    store.commit('user/SET_MESSAGE', num);
  }).catch(function (error) {
    ElementUI.Message({
      message: error.message,
      type: 'error'
    });
  });
}
export default notice;